import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CredentialListComponent } from './credential-list/credential-list.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { AngularMaterialModule } from '../../shared/material-module';
import { AddNewCredentialComponent } from './modals/add-new-credential/add-new-credential.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [
    CredentialListComponent,
    AddNewCredentialComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule
  ]
})
export class CredentialModule { }
